//@flow

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field } from 'redux-form';
import Input from '../../components/Input';
import handleSubmit from './handleSubmit';
import { requiredField } from '../../utilities/validations';
import { type FormProps } from 'redux-form';
import SubmitButton from '../../components/SubmitButton';
import {
  SignInDiv,
  SignInBackground,
  GirlImg,
  SignInMessageP,
  ActionsDiv
} from './SignInStyles';
import signInGirl from '../../assets/images/sign-in-girl.png';
import { ActionLink } from '../../components/LinkStyles';

type Props = {
  signInMessage?: string
} & FormProps;

class SignIn extends Component<Props> {
  render() {
    return (
      <SignInBackground>
        <SignInDiv>
          <h1>Partner Sign In</h1>
          {this.props.signInMessage && (
            <SignInMessageP>{this.props.signInMessage}</SignInMessageP>
          )}
          <form onSubmit={this.props.handleSubmit}>
            <Field
              name="email"
              label="Email"
              type="email"
              component={Input}
              validate={requiredField}
            />
            <Field
              name="password"
              label="Password"
              type="password"
              component={Input}
              validate={requiredField}
            />
            <SubmitButton
              value="LOG IN"
              disabled={this.props.submitting}
              error={this.props.error || this.props.signInErrorMessage}
              marginTop="3rem"
            />
          </form>
          <div>
            <ActionsDiv>
              <ActionLink to="/password_resets">
                Forgot your password
              </ActionLink>
            </ActionsDiv>
          </div>
          <GirlImg src={signInGirl} alt="" />
        </SignInDiv>
      </SignInBackground>
    );
  }
}

const mapStateToProps = state => ({
  signInErrorMessage: state.signIn.signInErrorMessage,
  signInMessage: state.signIn.signInMessage
});

export default connect(mapStateToProps)(
  reduxForm({ form: 'signIn', onSubmit: handleSubmit })(SignIn)
);
